<template>
	<div>
		<Header title="各类课表查询" type="0" route="/homeIndex"></Header>
		<div class="cantent">
			<div class="content" @click="fn(4)" v-if="timeKbFlag==1||timeKbFlag==0">
				<div class="left_box">
					<span class="sp">分时间段课表</span>
				</div>
				<div class="right_box"><i></i></div>
			</div>
			<div class="content" @click="fn(0)">
				<div class="left_box">
					<span class="sp">教师课表</span>
				</div>
				<div class="right_box"><i></i></div>
			</div>
			<div class="content" @click="fn(1)">
				<div class="left_box">
					<span class="sp">班级课表</span>
				</div>
				<div class="right_box"><i></i></div>
			</div>
			<div class="content" @click="fn(2)">
				<div class="left_box">
					<span class="sp">课程课表</span>
				</div>
				<div class="right_box"><i></i></div>
			</div>
			<div class="content" @click="fn(3)">
				<div class="left_box">
					<span class="sp">教室课表</span>
				</div>
				<div class="right_box"><i></i></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				Wholelist:[],
				recoreList:[],
				dm:'',
				studentNumber:'',
				code:sessionStorage.getItem('schoolCode'),
				timeKbFlag:JSON.parse(sessionStorage.getItem("userInfo")).userType
			}
		},
		methods:{
			fn(val){
				if('4'==val){
					this.$router.push({
					path:'/teacher/surCuseAll_Find_time',
					query:{
						'findType':val,	
					}
				})
				}else{
					this.$router.push({
					path:'/teacher/surCuseAll_Find',
					query:{
						'findType':val,	
					}
				})
				}
			},
		},
		created(){
			//this.dm = this.$route.query.dm;
			//this.studentNumber = this.$route.query.studentNumber;
		},
	}
</script>

<style lang="less" scoped>
	
	.class{
		color: #7469F8;
		font-size: 18px;
		margin-top: 10px;
		font-weight:600;
	}
	.cantent{
		width: 90%;
		margin: 70px auto 0;
	}
	.content{
		display: inline-block;
		position: relative;
		width: 100%;
		height: 82px;
		margin-top: 10px;
		background: #F8F8F8;
		border-radius: 5px;
	}
	.content::after{position: absolute;width: 3px;height: 100%;content: '';background-color: #7469F8;left: 0;border-radius: 5px 0 0 5px;}
	.content .left_box{
		width: 60%;
		height: 100%;
		margin-left: 20px;
		float: left;
	}
	.content .left_box .sp{
		display: block;
	}
	.content .left_box .sp{
		color: @attendance-color-1;
		line-height: 82px;
		font-weight:600;
	}
	
	.content .right_box{
		width: 25%;
		height: 100%;
		float: right;
	}
	.content .right_box i{
		display: inline-block;
		margin-top:35px;
		margin-left: 60px;
		width: 9px;
		height: 13px;
		background: url(../../../assets/images/back_right.png)center center no-repeat;
		background-size: 100%;
	}
	.foot{
		width: 90%;
		margin-left: 5%;
		height: 44px;
		/* margin-top: 100px; */
		position: fixed;
		bottom: 20px
	}
	.foot button{
		display: block;
		text-align: center;
		line-height: 44px;
		width: 100%;
		height: 44px;
		color: #7469F8;
		background: #ECEDFD;
		font-size: 16px ;
		border-radius: 3px;
	}
</style>


// WEBPACK FOOTER //
// src/components/teacher/teachCuseAll/typeList.vue